export const stringCollection = (val: string): string[] => val.split(';');
